"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTennesseeRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'TN';

function getTennesseeRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), (0, _commonRules.thriftSavingsPlans)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Relocation Assistance Payments',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 13-11-115',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.RELOCATION_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wearing Apparel',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-104',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CLOTHES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Schoolbooks, family pictures, portraits',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-104 (a)(3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.FAMILY_PHOTOS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Pension Plans',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-105',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.PENSION_PLAN];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Savings Account',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-105',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTH_SAVINGS_ACCOUNT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wages - 75% or 30 times federal min, plus $2.50 per week per child',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-106',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.UNPAID_WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wages of debtor deserting family, in hands of family',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-109',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WAGES_OF_DESERTING_FAMILY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Accident Insurance',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-110',
    limitAggregateSingle: 600,
    limitAggregateJoint: 1200,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.ACCIDENT_INSURANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security. Public assistance. Unemployment Compensation',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (1)(a)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.SOCIAL_SECURITY, _tertiaryTypes.UNEMPLOYMENT_COMPENSATION];
      return this.canTakeMoreExemptions() && (subType === _subTypes.PUBLIC_ASSISTANCE || validTertiaryTypes.includes(tertiaryType));
    }
  }, {
    id: idCounter.increment(),
    description: 'Veterans\' Benefit',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (1)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability benefits',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (1)(c)',
    limitAggregateSingle: 4000,
    limitAggregateJoint: 8000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA, IRA, ROTH IRA',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (1)(D)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validSubType = [_subTypes.IRA];
      var validTertiaryTypes = [_tertiaryTypes.ERISA_REITREMENT_PLAN];
      return this.canTakeMoreExemptions() && (validSubType.includes(tertiaryType) || validTertiaryTypes.includes(tertiaryType));
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Settlement',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (2)(B); Tenn. Code Ann. § 26-2-111 (2)(C)',
    limitAggregateSingle: 7500,
    limitAggregateJoint: 15000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, // NOTE: ???? How does this differ from individual
  // {
  //   id: idCounter.increment(),
  //   description: 'Total for personal injury, wrongful death and crime victims\' compensation',
  //   type: stateCode,
  //   statuteName: 'Tenn. Code Ann. § 26-2-111 (2)(B); Tenn. Code Ann. § 26-2-111 (2)(C)',
  //   limitAggregateSingle: 15000,
  //   limitAggregateJoint: 30000,
  //   limitPerItem: Number.MAX_SAFE_INTEGER,
  //   assetLimit: Number.MAX_SAFE_INTEGER,
  //   canApply(asset: Asset) {
  //     const subType = _.get(asset, 'assetJSON.subType');
  //     const validSubTypes = [PERSONAL_INJURY_COMPENSATION];
  //     return this.canTakeMoreExemptions()
  //       && validSubTypes.includes(subType);
  //   },
  // },
  {
    id: idCounter.increment(),
    description: 'Wrongful death recoveries',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (2)(B); Tenn. Code Ann. § 26-2-111 (2)(C)',
    limitAggregateSingle: 10000,
    limitAggregateJoint: 20000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.WRONGFUL_DEATH_AWARD];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Lost Future Earnings',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (4)',
    limitAggregateSingle: 1900,
    limitAggregateJoint: 3800,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony, child support - owed 30 days before filing',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111 (e)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Aids',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-111(5)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Crime Victim\'s Compensation',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 29-13-111',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.CRIME_VICTIM_COMPENSATION];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Education Plans and Trusts',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 49-4-108; Tenn. Code Ann. § 49-7-822',
    limitAggregateSingle: 4000,
    limitAggregateJoint: 8000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.TUITION_TRUST, _tertiaryTypes.PREPAID_COLLEGE_TRUST];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Teachers Retirement Fund',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 49-5-909',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTertiaryTypes = [_tertiaryTypes.TEACHERS_PENSION];
      return this.canTakeMoreExemptions() && validTertiaryTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 50-6-223',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Benefits, Societal Benefits',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 56-25-1403',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Annuities',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 56-7-203',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.ANNUITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (for spouse)',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 56-7-203',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Old Age Assistance',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 71-2-216',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.OLD_AGE_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Aid to Disabled',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 71-4-1112',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Aid to Blind',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 71-4-117',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.AID_TO_BLIND;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employees',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 8-36-111',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.PUBLIC_EMPLOYEE_PENSION];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    type: stateCode,
    statuteName: 'Tenn. Code Ann. § 26-2-103',
    limitAggregateSingle: 10000,
    limitAggregateJoint: 20000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}